export const policiesForLanguageSchoolsNodes = [
  {
    value: "iii-policies-for-the-language-schools",
    label: "III. Policies for the Language Schools",
    className: "iii-policies-for-the-language-schools",
    children: [
      {
        value: "iii-policies-for-the-language-schools/a-student-life-policies",
        label: "A. Student Conduct Policies",
        className: "a-student-life-policies",
        children: [
          {
            value:
              "iii-policies-for-the-language-schools/a-student-life-policies/disciplinary-process",
            label: "Language Schools Disciplinary Process",
            className: "disciplinary-process",
          },
          {
            value:
              "iii-policies-for-the-language-schools/a-student-life-policies/withdrawals-and-readmission",
            label: "Withdrawals and Readmission",
            className: "withdrawals-and-readmission",
          },
        ],
      },
      {
        value: "iii-policies-for-the-language-schools/b-academic-policies",
        label: "B. Academic Policies",
        className: "b-academic-policies",
        children: [
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-1-academic-honesty",
            label: "B.1 Academic Honesty",
            className: "b-1-academic-honesty",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-2-language-pledge",
            label: "B.2 Language Pledge",
            className: "b-2-language-pledge",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-3-general-policies",
            label: "B.3 General Policies",
            className: "b-3-general-policies",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-4-registration",
            label: "B.4 Registration",
            className: "b-4-registration",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-5-for-middlebury-college-undergraduates",
            label: "B.5 For Middlebury College Undergraduates",
            className: "b-5-for-middlebury-college-undergraduates",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-6-master-of-arts",
            label: "B.6 Master of Arts",
            className: "b-6-master-of-arts",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-7-master-of-arts-in-teaching-in-secondary-education",
            label: "B.7 Master of Arts in Teaching in Secondary Education",
            className: "b-7-master-of-arts-in-teaching-in-secondary-education",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-8-doctor-of-modern-languages",
            label: "B.8 Doctor of Modern Languages",
            className: "b-8-doctor-of-modern-languages",
          },
          {
            value:
              "iii-policies-for-the-language-schools/b-academic-policies/b-9-student-records",
            label: "B.9 Grades and Transcripts",
            className: "b-9-student-records",
          }
        ],
      },
      {
        value: "iii-policies-for-the-language-schools/c-financial-policies",
        label: "C. Financial Policies",
        className: "c-financial-policies",
        children: [
          {
            value:
              "iii-policies-for-the-language-schools/c-financial-policies/c-1-fees",
            label: "C.1 Fees",
            className: "c-1-fees",
          },
          {
            value:
              "iii-policies-for-the-language-schools/c-financial-policies/c-2-employment",
            label: "C.2 Employment",
            className: "c-2-employment",
          },
          {
            value:
              "iii-policies-for-the-language-schools/c-financial-policies/c-3-withdrawals-and-refunds",
            label: "C.3 Withdrawals and Refunds",
            className: "c-3-withdrawals-and-refunds",
          },
        ],
      },
      {
        value:
          "iii-policies-for-the-language-schools/d-residential-life-policies",
        label: "D. Residential Life Policies",
        className: "d-residential-life-policies",
      },
      {
        value: "iii-policies-for-the-language-schools/e-policies-for-faculty",
        label: "E. Policies for Faculty",
        className: "e-policies-for-faculty",
      },
    ],
  }
]